import { gql } from '@apollo/client';

export const GET_MARKETPLACE_USERS_QUERY = gql`
  query GetMarketplaceUsers($searchTerm: String, $userIds: [String!]) {
    getMarketplaceUsers(searchTerm: $searchTerm, userIds: $userIds) {
      addresses
      pfp
      stoodioUsername
      userId
    }
  }
`;
